import React, { useState, useEffect } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useNavigate } from "react-router-dom";
import { getter } from "@progress/kendo-react-common";
import { useDispatch } from "react-redux";
import InboxDetail from "./InboxDetail";
import { DisplayMsg } from "../../services/toastService";
import { loadInboxGridData } from "../../handlers/InboxBoxGridHandler";
import useReloadButton from "../../CustomHooks/useReloadButton";
import { useKendoGridHandlers } from "../../CustomHooks/useKendoGridHandlers";
import { setUrl } from "../../handlers";
import { setCurrentTab } from "../../store/reducers/SharedLayoutDataSlice";

const DATA_ITEM_KEY = "TICKET_NO";
const SELECTED_FIELD = "selected";

const idGetter = getter(DATA_ITEM_KEY);

export const DEFAULT_GRID_INFO_INBOX = {
  action: "ALL_INBOX_DATA",
  className: "TICKETDETAIL",
  pageSize: 20,
  currentPageNumber: 1,
  sortName: "ENTERED_DATE",
  sortOrder: "desc",
  gridHeight: "300px",
};

const PAGER_SETTINGS = {
  info: true,
  type: "input",
  previousNext: true,
  pageSize: 4,
  refresh: true,
};

const KendoInboxGrid = React.memo((props) => {
  const dispatch = useDispatch();

  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(0);
  const [Detail, setDetail] = useState(false);
  const [description, setDescription] = useState(false);

  const [reloadToggle, setReloadToggle] = useState(false);
  const navigate = useNavigate();

  const [gridState, setGridState] = useState({
    pageNumber: DEFAULT_GRID_INFO_INBOX.currentPageNumber,
    pageSize: DEFAULT_GRID_INFO_INBOX.pageSize,
    sortName: DEFAULT_GRID_INFO_INBOX.sortName,
    sortOrder: DEFAULT_GRID_INFO_INBOX.sortOrder,
    sort: [
      {
        field: DEFAULT_GRID_INFO_INBOX.sortName,
        dir: DEFAULT_GRID_INFO_INBOX.sortOrder?.toLowerCase() || "asc",
      },
    ],
  });

  const [selectedState, setSelectedState] = React.useState();

  const { HandleDataStateChange, HandlePageChange } =
    useKendoGridHandlers(setGridState);

  // UseEffect to load the grid data
  useEffect(() => {
    loadInboxGridData(gridState).then((response) => {
      setGridData(response.rows);
      setTotal(response.total);
    });
  }, [gridState, reloadToggle]);

  useReloadButton(setReloadToggle);

  const ShowClientDetail = (currentClient) => {
    navigate("/client-detail");
  };

  const SelectedContentLength = () => {
    const selectedText = window.getSelection().toString();
    return selectedText.length > 0;
  };

  const onSelectionChange = React.useCallback(
    (event) => {
      const check = SelectedContentLength();
      if (!check) {
        const newSelectedState = getSelectedState({
          event,
          selectedState,
          dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);
        const currentColumn = event.target._columns[event.endColIndex].field;
        if (currentColumn === "PRACTICE_NAME") {
          ShowClientDetail(event.dataItems[event.endRowIndex]);
        }
      }
    },
    [selectedState]
  );

  const ShowTicketDetail = (ticketId) => {
    navigate("/ticketDetail", {
      state: {
        ticketNo: ticketId,
      },
    });
  };

  const TicketNoField = (props) => (
    <td>
      <p
        style={{
          textAlign: "left",
          color: "#0b70b8",
          cursor: "pointer",
          margin: "0px",
        }}
        className="link pl-3"
        onClick={() => ShowTicketDetail(props.dataItem.TICKET_NO)}
      >
        {props.dataItem.TICKET_NO}
      </p>
    </td>
  );

  const TypeField = (props) => (
    <td>
      <p style={{ textAlign: "left", margin: "0px" }}>
        {ShowCurrentType(props.dataItem.TYPE)}
      </p>
    </td>
  );

  const ShowCurrentType = (type) => {
    if (type === "ASSIGNEE") {
      return "Assignee Detail";
    }
    if (type === "COMMENTS") {
      return "Comments Added";
    }
    if (type === "TEAM") {
      return "Team Detail";
    }
    if (type === "STATUS") {
      return "Status Detail";
    }
    return "";
  };

  const ShowInboxDetail = (props) => {
    const data = props.dataItem;
    const readFlag = data.VIEW_STATUS || "";
    const seqNum = data.SEQ_NUM || "";
    const blob = data.email_blob || "";

    const desc = blob || data.EMAIL_TEXT;
    setDescription(desc);
    if (readFlag && readFlag === "N") {
      ChangeTicketStatus(seqNum);
    } else {
      setDetail(true);
    }
  };

  const ChangeTicketStatus = (seqNum) => {
    try {
      let queryParams = null;
      const userseqNum = sessionStorage.SEQ_NUM;
      const userName = sessionStorage.USER;
      const formdata = new FormData();
      formdata.append("SeqNum", seqNum);
      formdata.append("USERSEQNUM", userseqNum);
      formdata.append("USERNAME", userName);

      queryParams = new URLSearchParams({
        userType: sessionStorage.type,
        CP: sessionStorage.CP,
        APPUSER: sessionStorage.USER,
        Reseller: sessionStorage.Reseller,
      }).toString();
      fetch(setUrl("TICKETDETAIL", "CHANGE_TICKET_STATUS") + queryParams, {
        method: "POST",
        body: formdata,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            setDetail(true);
          } else {
            DisplayMsg("2", result.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (e) {
      const params = "params";
      const data = `CLASS_NAME=support_Inbox.js&METHOD_NAME=ChangeTicketStatus&METHOD_PARAM=params:${params}&EXCEPTION_MSG=${e.message}&STACK_TRACE=${e.stack}`;
    }
  };

  const DescriptionField = (props) => (
    <td>
      <p
        style={{
          textAlign: "left",
          color: "#0b70b8",
          cursor: "pointer",
          margin: "0px",
        }}
        onClick={() => ShowInboxDetail(props)}
      >
        {ShowDescription(props.dataItem.DESCRIPTION)}
      </p>
    </td>
  );

  const ShowDescription = (type) => {
    if (type === "NEUROLOGY") {
      return "Click to view Message Detail";
    }
    return "Click to view Message Detail";
  };

  const CurrentStatus = (props) => {
    const type = props.dataItem.VIEW_STATUS;
    if (type === "N") {
      return (
        <td className="pl-4">
          <p style={{ textAlign: "left", margin: "0px" }}>UnRead</p>
        </td>
      );
    }
    if (type === "Y") {
      return (
        <td className="pl-4">
          <p style={{ textAlign: "left", margin: "0px" }}>Read</p>
        </td>
      );
    }
    return (
      <td className="pl-4">
        <p style={{ textAlign: "left", margin: "0px" }} />
      </td>
    );
  };

  const HandleSetInbox = (childData) => {
    setDetail(false);
  };

  return (
    <>
      {Detail && (
        <InboxDetail data={description} parentCallback={HandleSetInbox} />
      )}

      <Tooltip openDelay={100} position="right" anchorElement="target">
        <Grid
          style={{
            height: "calc(100vh - 175px)",
          }}
          scrollable="scrollable"
          total={total}
          skip={(gridState.pageNumber - 1) * gridState.pageSize}
          pageSize={gridState.pageSize}
          filterable={false}
          sortable={{
            mode: "single",
            allowUnsort: false,
          }}
          sort={gridState.sort}
          selectedField={SELECTED_FIELD}
          data={gridData.map((item) => ({
            ...item,
            [SELECTED_FIELD]: selectedState?.[idGetter(item)] || false,
          }))}
          selectable={{
            enabled: true,
            drag: false,
            cell: false,
            mode: "multiple",
          }}
          pageable={PAGER_SETTINGS}
          onPageChange={HandlePageChange}
          onDataStateChange={HandleDataStateChange}
          onSelectionChange={onSelectionChange}
        >
          <GridColumn
            title="Ticket #"
            field="TICKET_NO"
            cell={TicketNoField}
            sortable
          />
          <GridColumn
            title="Type"
            field="TYPE"
            cell={TypeField}
            filterable={false}
          />
          <GridColumn
            title="Message History"
            field="DESCRIPTION"
            cell={DescriptionField}
          />
          <GridColumn title="Status" field="VIEW_STATUS" cell={CurrentStatus} />
          <GridColumn title="Date" field="ENTERED_DATE" filterable={false} />
        </Grid>
      </Tooltip>
    </>
  );
});
export default KendoInboxGrid;
